import { makeObservable, computed } from "mobx";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import { SessionEvent, SessionEventModelData } from "./types";
import { SyncUpdateValue } from "@/store/sync/types";
import { JsonObject } from "type-fest";

export class SessionEventObservable extends BaseSyncModel<SessionEventModelData> {
  public modelKind = SyncModelKind.SessionEvent;

  constructor({
    id,
    data,
    store,
  }: { id: string; data: SyncUpdateValue<SessionEventModelData> } & WithAppStore) {
    super({ id, data, store });

    makeObservable(this, {
      modelKind: false,
      sessionId: computed,
      locallyCreatedAt: computed,
      kind: computed,
      eventValue: computed,
      context: computed,
      export: true,
    });
  }

  get sessionId() {
    return this.modelData.session_id;
  }

  get locallyCreatedAt() {
    return new Date(this.modelData.locally_created_at);
  }

  get kind() {
    return this.modelData.kind;
  }

  get eventValue() {
    return this.modelData.value_json as JsonObject;
  }

  get context() {
    return undefined;
  }

  export(): SessionEvent {
    return {
      id: this.id,
      session_id: this.sessionId,
      locally_created_at: this.locallyCreatedAt.toISOString(),
      internal_created_at: this.locallyCreatedAt.toISOString(),
      internal_updated_at: this.locallyCreatedAt.toISOString(),
      data: {
        kind: this.kind,
        value: this.eventValue,
      } as SessionEvent["data"],
    };
  }
}
